import { render, staticRenderFns } from "./LetterAvatar.vue?vue&type=template&id=716b41b0&scoped=true"
import script from "./LetterAvatar.vue?vue&type=script&lang=js"
export * from "./LetterAvatar.vue?vue&type=script&lang=js"
import style0 from "./LetterAvatar.vue?vue&type=style&index=0&id=716b41b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b41b0",
  null
  
)

export default component.exports